export default __webpack_public_path__ + "c65ed88a9666fab1c6f0f27c11ee5e2c.svg";